/*
  Carter & Me — add to bag feedback.

  Dawn's product-form already does the important half: it intercepts the
  submit, posts to /cart/add.js, and hands the result to whatever
  registers as cart-notification, which here is the floating bag. Scroll
  position is untouched because nothing navigates.

  What it does not do is say "Added" on the button. It shows a spinner and
  then opens the bag, and if the bag is missed the click reads as though
  nothing happened, which is when people click twice and end up with two
  of something.

  So this adds only the button state, and leaves the posting to Dawn.
  Nothing here is required for the add to work: if this file fails, the
  add still happens and the bag still opens.
*/

(function () {
  const HOLD = 1600;

  function label(button) {
    // Dawn buttons keep their text in a span; card buttons do not.
    return button.querySelector('.cm-add-label')
      || button.querySelector('span:not(.loading__spinner):not([class*="loading"])')
      || button;
  }

  function flash(button) {
    if (!button || button.dataset.cmFlashing === 'true') return;
    const target = label(button);
    const original = target.textContent;
    button.dataset.cmFlashing = 'true';
    target.textContent = button.dataset.addedLabel || 'Added';
    setTimeout(() => {
      target.textContent = original;
      delete button.dataset.cmFlashing;
    }, HOLD);
  }

  // The add is complete when the cart section re-renders, so listen for
  // the submit and confirm against the cart rather than guessing a delay.
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    // No product-form ancestor means Dawn is not intercepting and the
    // browser is about to navigate. Saying "Added" then would be a lie.
    if (!form.closest('product-form')) return;

    const button = form.querySelector('[type="submit"]');
    if (!button) return;

    const before = document.querySelector('[data-cm-bag-count]');
    const beforeCount = before ? before.textContent.trim() : null;

    // Wait for the floating bag to update the count, then confirm.
    let tries = 0;
    const check = setInterval(() => {
      tries += 1;
      const now = document.querySelector('[data-cm-bag-count]');
      const changed = now && now.textContent.trim() !== beforeCount;
      if (changed) {
        clearInterval(check);
        flash(button);
      } else if (tries > 40) {
        // ~4s. The add failed or the count is not on this page; say
        // nothing rather than claim success.
        clearInterval(check);
      }
    }, 100);
  });
})();
